import type { Currency } from "../Currency.js";
import type { ExchangeRate } from "../ExchangeRatesSetting.js";
import { convertPriceInCzkToCurrency } from "./convertPriceInCzkToCurrency.js";
import { convertPriceToCzk } from "./convertPriceToCzk.js";

export function convertToCurrency(
	price: number,
	currency: Currency,
	targetCurrency: Currency,
	exchangeRates: ExchangeRate[],
): number {
	if (currency === targetCurrency) {
		return price;
	}
	const czk = convertPriceToCzk(price, currency, exchangeRates);
	return convertPriceInCzkToCurrency(czk, targetCurrency, exchangeRates);
}
